import type {
  ContentListRevisionsInput,
  ContentListRevisionsOutput,
  ContentReadRevisionInput,
  ContentReadRevisionOutput,
  ContentRestoreRevisionInput,
  ContentRestoreRevisionOutput,
} from '@vivport/backend/types';
import { requireToolOutput } from './templates-api';
import { executeTool } from './tools-api';

export const listRevisions = async (input: ContentListRevisionsInput): Promise<ContentListRevisionsOutput> =>
  requireToolOutput(
    await executeTool<ContentListRevisionsInput, ContentListRevisionsOutput>('content.listRevisions', input)
  );

export const readRevision = async (input: ContentReadRevisionInput): Promise<ContentReadRevisionOutput> =>
  requireToolOutput(
    await executeTool<ContentReadRevisionInput, ContentReadRevisionOutput>('content.readRevision', input)
  );

export const restoreRevision = async (
  input: ContentRestoreRevisionInput
): Promise<ContentRestoreRevisionOutput> =>
  requireToolOutput(
    await executeTool<ContentRestoreRevisionInput, ContentRestoreRevisionOutput>('content.restoreRevision', input)
  );
